import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const svgIcons = new Set<string>([
  'alix-camera-capture-circle',
  'alix-flip-baggage',
]);

@Injectable({
  providedIn: 'root',
})
export class AppIconRegister {
  private iconRegistry = inject(MatIconRegistry);

  private sanitizer = inject(DomSanitizer);

  register() {
    svgIcons.forEach((svgIcon: string) => {
      this.iconRegistry.addSvgIcon(
        svgIcon,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${svgIcon}.svg`),
      );
    });
  }
}
